/* eslint-disable react/prop-types */
import { DatePicker } from 'antd';
import moment from 'moment';
import React from 'react';
import { COLLECTION_DATE_OTHER_OPTION } from '../SelectProposedDateStep';
import { API_DATETIME_FORMAT } from '../../../shared/constants';

const getDateValue = (date) => {
  if (date === COLLECTION_DATE_OTHER_OPTION) return null;
  return moment(date);
};

const SelectOtherDateStep = ({
  dateOptionSelected,
  handleDatePickerSelected,
  originalCollectionDateTime,
}) => {
  const disabledDate = (current) => (current ? current.isBefore(moment().startOf('day')) : false);

  const onChange = (selectedDate) => {
    const formattedDate = moment(selectedDate).format(API_DATETIME_FORMAT);
    handleDatePickerSelected(formattedDate);
  };

  return (
    <div>
      <h3>Pick the date and time you would like to reschedule collection to</h3>
      <p>
        Once the new date and time are confirmed, the booking collection date will be updated and all garage
        invitations will be cancelled.
      </p>
      <br />
      <DatePicker
        value={getDateValue(dateOptionSelected)}
        disabledDate={disabledDate}
        showTime={{
          defaultValue: moment(originalCollectionDateTime),
        }}
        onChange={onChange}
      />
    </div>
  );
};

export default SelectOtherDateStep;
